<dx-popup
  [(visible)]="visible"
  [showTitle]="true"
  title="Créer une Intervention Manuelle"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [width]="1200"
  [maxHeight]="'90vh'"
  [height]="'auto'"
  (onHiding)="close()"
>
  <div *dxTemplate="let data of 'content'">
    <div class="manual-intervention-dialog-content">
      <div class="grid grid-cols-2 gap-4 mb-4 content-grid">
        <!-- Left Column: Form -->
        <div class="form-section">
          <dx-scroll-view class="form-scroll-view">
            <dx-form
              [formData]="form"
              [colCount]="1"
              [labelLocation]="'top'"
              [readOnly]="isSubmitting">
            
            <!-- Required Fields Section -->
            <dxi-item itemType="group" caption="Champs Obligatoires">
              <dxi-item 
                dataField="trailer_id" 
                editorType="dxSelectBox" 
                [isRequired]="true"
                [label]="{text: 'Remorque *'}"
                [editorOptions]="{
                  dataSource: trailers,
                  displayExpr: 'name',
                  valueExpr: 'id',
                  searchEnabled: true,
                  searchMode: 'contains',
                  searchExpr: ['name', 'code'],
                  placeholder: 'Sélectionner une remorque'
                }">
              </dxi-item>

              <dxi-item 
                dataField="vehicle_id" 
                editorType="dxSelectBox" 
                [isRequired]="true"
                [label]="{text: 'Tracteur *'}"
                [editorOptions]="{
                  dataSource: vehicles,
                  displayExpr: 'name',
                  valueExpr: 'id',
                  searchEnabled: true,
                  searchMode: 'contains',
                  searchExpr: ['name'],
                  placeholder: 'Sélectionner un tracteur'
                }">
              </dxi-item>

              <dxi-item 
                dataField="field_id" 
                editorType="dxSelectBox" 
                [isRequired]="true"
                [label]="{text: 'Parcelle *'}"
                [editorOptions]="fieldSelectBoxOptions">
              </dxi-item>

              <dxi-item 
                dataField="crop_id" 
                editorType="dxSelectBox" 
                [isRequired]="false"
                [label]="{text: 'Culture'}"
                [editorOptions]="{
                  dataSource: crops,
                  displayExpr: 'name',
                  valueExpr: 'id',
                  searchEnabled: true,
                  searchMode: 'contains',
                  searchExpr: ['name', 'code'],
                  placeholder: 'Sélectionner une culture (optionnel)',
                  allowClearing: true
                }">
              </dxi-item>

              <dxi-item 
                dataField="start_time" 
                editorType="dxDateBox" 
                [isRequired]="true"
                [label]="{text: 'Date et Heure de Début *'}"
                [editorOptions]="{
                  type: 'datetime',
                  useMaskBehavior: true,
                  showClearButton: true
                }">
              </dxi-item>

              <dxi-item 
                dataField="stop_time" 
                editorType="dxDateBox" 
                [isRequired]="true"
                [label]="{text: 'Date et Heure de Fin *'}"
                [editorOptions]="stopTimeEditorOptions">
              </dxi-item>

              <dxi-item itemType="simple">
                <div class="mb-2">
                  <label class="block text-sm font-medium mb-1">Superficie Travaillée *</label>
                  <div class="flex items-center gap-2">
                    <span class="text-lg font-semibold">{{ workingAreaHa.toFixed(2) }} Ha</span>
                    <span class="text-sm text-gray-500">({{ (form.working_area || 0).toFixed(0) }} m²)</span>
                  </div>
                  <p class="text-xs text-gray-500 mt-1">Calculée automatiquement depuis la zone dessinée sur la carte</p>
                </div>
              </dxi-item>
            </dxi-item>

            <!-- Optional Fields Section -->
            <dxi-item itemType="group" caption="Champs Optionnels">
              <dxi-item itemType="group" caption="Durées (secondes)">
                <dxi-item dataField="working_in_field_move_duration" editorType="dxNumberBox" [label]="{text: 'Travail sur parcelle (mouvement)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
                <dxi-item dataField="working_in_field_idle_duration" editorType="dxNumberBox" [label]="{text: 'Travail sur parcelle (inactif)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
                <dxi-item dataField="working_in_field_off_duration" editorType="dxNumberBox" [label]="{text: 'Travail sur parcelle (arrêt)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
                <dxi-item dataField="working_out_field_move_duration" editorType="dxNumberBox" [label]="{text: 'Travail hors parcelle (mouvement)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
                <dxi-item dataField="working_out_field_idle_duration" editorType="dxNumberBox" [label]="{text: 'Travail hors parcelle (inactif)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
                <dxi-item dataField="working_out_field_off_duration" editorType="dxNumberBox" [label]="{text: 'Travail hors parcelle (arrêt)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
                <dxi-item dataField="road_move_duration" editorType="dxNumberBox" [label]="{text: 'Trajet (mouvement)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
                <dxi-item dataField="road_idle_duration" editorType="dxNumberBox" [label]="{text: 'Trajet (inactif)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
                <dxi-item dataField="road_off_duration" editorType="dxNumberBox" [label]="{text: 'Trajet (arrêt)'}" [editorOptions]="{min: 0, format: '#0'}"></dxi-item>
              </dxi-item>

              <dxi-item itemType="group" caption="Vitesse (km/h)">
                <dxi-item dataField="working_in_field_speed_avg" editorType="dxNumberBox" [label]="{text: 'Vitesse moyenne'}" [editorOptions]="{min: 0, format: '#0.##'}"></dxi-item>
                <dxi-item dataField="working_in_field_speed_max" editorType="dxNumberBox" [label]="{text: 'Vitesse maximale'}" [editorOptions]="{min: 0, format: '#0.##'}"></dxi-item>
              </dxi-item>

              <dxi-item itemType="group" caption="Pression (Bar)">
                <dxi-item dataField="pressure_avg" editorType="dxNumberBox" [label]="{text: 'Pression moyenne'}" [editorOptions]="{min: 0, format: '#0.##'}"></dxi-item>
                <dxi-item dataField="pressure_max" editorType="dxNumberBox" [label]="{text: 'Pression maximale'}" [editorOptions]="{min: 0, format: '#0.##'}"></dxi-item>
              </dxi-item>

              <dxi-item itemType="group" caption="Carburant">
                <dxi-item dataField="total_fuel_consumption" editorType="dxNumberBox" [label]="{text: 'Consommation totale (L)'}" [editorOptions]="{min: 0, format: '#0.##'}"></dxi-item>
                <dxi-item dataField="fuel_consumption_per_hectare" editorType="dxNumberBox" [label]="{text: 'Consommation par hectare (L/ha)'}" [editorOptions]="{min: 0, format: '#0.##'}"></dxi-item>
              </dxi-item>
            </dxi-item>
            </dx-form>
          </dx-scroll-view>
        </div>

        <!-- Right Column: Map -->
        <div class="map-section">
          <div class="mb-2">
            <label class="block text-sm font-medium mb-1">Zone de Travail *</label>
            <p class="text-xs text-gray-500">Utilisez l'outil de dessin pour tracer la zone de travail sur la carte</p>
          </div>
          <div class="map-container" style="border: 1px solid #ddd; border-radius: 4px;">
            <div
              leaflet
              [leafletOptions]="mapOptions"
              (leafletMapReady)="onMapReady($event)"
              style="height: 100%; width: 100%;">
            </div>
          </div>
        </div>
      </div>
      
      <!-- Footer buttons -->
      <div class="p-4 border-t flex justify-end gap-2 mt-4">
        <dx-button
          text="Annuler"
          (onClick)="close()"
          [disabled]="isSubmitting">
        </dx-button>
        <dx-button
          text="Créer"
          type="success"
          (onClick)="submit()"
          [disabled]="!isFormValid() || isSubmitting">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>

